import { render, staticRenderFns } from "./FirmwareUpdates.vue?vue&type=template&id=6fbf13bb&scoped=true"
import script from "./FirmwareUpdates.vue?vue&type=script&lang=js"
export * from "./FirmwareUpdates.vue?vue&type=script&lang=js"
import style0 from "./FirmwareUpdates.vue?vue&type=style&index=0&id=6fbf13bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf13bb",
  null
  
)

export default component.exports